var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9752",
    "data-name": "Rectangle 9752",
    width: 83,
    height: 83,
    transform: "translate(-23795 -21816)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(23795 21816)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(-193.999 128.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "translate(-23601 -21944.676)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.431,
    cy: 41.431,
    rx: 41.431,
    ry: 41.431,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.431,
    cy: 41.431,
    rx: 39.931,
    ry: 39.931,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(-23582.174 -21939.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M453.1,561.577h.009a.14.14,0,0,0,.01-.02Zm.916,15.671s0,0,0,.006l0,0s0,0,0,0Zm.238-17.971.009,0c0-.007.007-.014.011-.021Z",
    transform: "translate(-432.573 -527.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M334.233,371.191l13.126-34.342-.136-.069Q328.5,357.751,309.67,378.85l20,3.519c-2.984,9.483-5.933,18.852-8.882,28.222l.117.063c11.035-13.1,22.07-26.209,33.231-39.464ZM325.287,402.9c.661-1.548,1.317-3.1,1.985-4.646q4.2-9.707,8.4-19.413c.4-.923.243-1.156-.757-1.158q-10.446-.024-20.893-.039c-.422,0-.846.046-1.437.082l29.773-33.344.1.064c-.378.754-.753,1.51-1.136,2.261Q335,359.128,328.67,371.547c-.438.859-.286,1.086.7,1.088q10.375,0,20.75,0h.92l-25.65,30.328Zm5.788-16.256a.341.341,0,0,1,.014-.034l.011.01.013-.013,0,0s0,0,0,0l0,0c0,.006-.007.01-.007.011l0,0C331.091,386.628,331.083,386.637,331.074,386.646Zm.3-18.025c0,.009,0,.017,0,.026s-.006,0-.009,0l-.009,0Zm-1.151,2.318H330.2l.019-.019h0A.107.107,0,0,0,330.22,370.939Z",
    transform: "translate(-309.67 -336.78)",
    fill: "#001d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M368.5,418.164l-25.65,30.328-.1-.063c.661-1.548,1.317-3.1,1.985-4.645q4.2-9.708,8.4-19.414c.4-.923.243-1.156-.757-1.158q-10.446-.024-20.893-.039c-.422,0-.846.046-1.437.082l29.773-33.344.1.064c-.378.754-.753,1.51-1.136,2.261q-6.326,12.419-12.656,24.838c-.438.859-.286,1.086.7,1.088q10.375,0,20.75,0Z",
    transform: "translate(-327.133 -382.306)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M453.12,561.557h0l-.019.019h.023A.12.12,0,0,1,453.12,561.557Zm1.133-2.28.009,0s.006,0,.009,0,0-.017,0-.026Z",
    transform: "translate(-432.573 -527.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M453.123,575.331H453.1l.019-.019h0A.118.118,0,0,0,453.123,575.331Z",
    transform: "translate(-432.573 -541.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M461.18,559.26c0,.009,0,.017,0,.026s-.006,0-.009,0l-.009,0Z",
    transform: "translate(-439.48 -527.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M459.256,684.98l-.026.024c0-.012.009-.023.014-.034Z",
    transform: "translate(-437.826 -635.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M459.427,684.93s0,0,0,0l0,0c0,.006-.007.01-.007.011l0,0,.013-.013Z",
    transform: "translate(-437.98 -635.105)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowering);
export default __webpack_public_path__ + "static/media/powering.f65b4147703b114d526f1959d2e59477.svg";
export { ForwardRef as ReactComponent };